import { useTranslation } from 'react-i18next';
import { createElement, useState } from 'react';
import { TypeSmallIconCards } from '../form/form-fields/TypeSmallIconCards';
import ShortTextIcon from '@mui/icons-material/ShortText';
import NumbersIcon from '@mui/icons-material/Numbers';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { NewMatchingPropertyText } from '../exo/matching-properties/NewMatchingPropertyText';
import { Box, Button, IconButton, useTheme } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { NewMatchingPropertyNumber } from '../exo/matching-properties/NewMatchingPropertyNumber';
import { NewMatchingPropertyCheckbox } from '../exo/matching-properties/NewMatchingPropertyCheckbox';
import { NewMatchingPropertySelect } from '../exo/matching-properties/NewMatchingPropertySelect';
import DeleteIcon from '@mui/icons-material/Delete';
import ExoAlert from '../exo/ExoAlert';
import { tokens } from '../../global/theme/tokens';
import { API_DELETE, DBRequest, useConfig } from '../../api/api';
import Loader from '../special/Loader';

export const NewMatchingProperty = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onFeedback,
  salesLevelId,
  startType,
  salesObjectId,
  onDelete,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [selectedType, setSelectedType] = useState(startType || {});
  const [reqDel, setReqDel] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  function handleChange(key, data) {
    setSelectedType(data);
  }

  const typeMap = {
    text: NewMatchingPropertyText,
    number: NewMatchingPropertyNumber,
    checkbox: NewMatchingPropertyCheckbox,
    select: NewMatchingPropertySelect,
  };

  function handleUpdate(data) {
    onClose();
    onUpdate(data);
  }
  function handleCreate(data) {
    onClose();
    onCreate(data);
  }

  function handleDelete(element) {
    DBRequest({
      config,
      path: `sales-object-properties/${element.id}`,
      method: API_DELETE,
      onResponse: () => {
        onClose();
        onDelete(element);
      },
      onLoading: setIsLoading,
      onFeedback,
    });
  }
  return (
    <Box
      className="flex flex-col w-full gap-3"
      sx={{
        '& .delButton': {
          transition: '0.3s ease',
          bgcolor: colors.error + '30',
          color: colors.error,
          border: `1px solid ${colors.error}80`,
          opacity: 1,
          transform: 'translate(0px)',
        },
        ':hover': {
          '& .editButton, & .delButton': {
            opacity: 1,
            transform: 'translate(0px)',
          },
        },
      }}
    >
      <Loader active={isLoading} />
      {/* Row with TypeSmallIconCards and Delete Button */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <TypeSmallIconCards
          dataCollection={{ type: selectedType }}
          updateValidationOnChange={handleChange}
          field={{
            label: t('Type') + ':',
            key: 'type',
            cards: [
              {
                label: t('text'),
                Icon: ShortTextIcon,
                value: 'text',
              },
              {
                label: t('number'),
                Icon: NumbersIcon,
                value: 'number',
              },
              {
                label: t('yes/no'),
                Icon: CheckBoxIcon,
                value: 'checkbox',
              },
              {
                label: t('select'),
                Icon: FormatListBulletedIcon,
                value: 'select',
              },
            ],
          }}
        />
        {/* delete button - only show when editing lead*/}
        {startData && startData.id && startData.isGlobal === true && (
          <IconButton
            onClick={() => setReqDel(startData)}
            size="small"
            className="delButton"
            sx={{ ml: 2 }}
          >
            <DeleteIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        )}
      </Box>

      {typeMap[selectedType] &&
        createElement(typeMap[selectedType], {
          onUpdate: handleUpdate,
          onCreate: handleCreate,
          startData,
          onClose,
          onFeedback,
          salesLevelId,
        })}
      <ExoAlert
        onSubmit={() => handleDelete(reqDel)}
        open={Boolean(reqDel)}
        onClose={() => setReqDel(null)}
        alert={{
          submitLabel: t('Delete'),
          message: t(`Are you sure you want to permanently delete this entry?`),
        }}
      />
    </Box>
  );
};
